import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { string, func } from 'prop-types'
import { result } from 'lodash'

import { removeNotif } from '../../modules/Main'

import './Notification.scss'

class Notification extends Component {
  static defaultProps = {
    notif: '',
  }

  static propTypes = {
    notif: string,
    removeNotif: func.isRequired,
  }

  constructor(props) {
    super(props)
    this.currentTimeout = null
    this.closeTimeout = null
  }

  state = {
    active: false,
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.notif && this.props.notif !== nextProps.notif) {
      this.schedule()
    }
  }

  schedule = () => {
    this.setState(
      {
        active: true,
      },
      () => {
        this.closeTimeout = setTimeout(() => {
          this.setState({
            active: false,
          })
        }, 2000)
        this.currentTimeout = setTimeout(() => {
          this.props.removeNotif()
        }, 2500)
      },
    )
  }

  render() {
    const { notif } = this.props
    const { active } = this.state
    return (
      <div className={`notif-wrapper ${active ? 'animate' : ''} ${result(notif, 'type', '')}`}>
        {result(notif, 'message', '')}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  notif: state.main.notif,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      removeNotif,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(Notification)



// WEBPACK FOOTER //
// ./src/common/Notification/index.js